import getLocale from "./getLocale";

const locale = getLocale();

const formatNumber = (value: string | undefined) => {
  if (!value) return "";

  const number = Number(value);
  return new Intl.NumberFormat(locale.code, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(number);
};

export default formatNumber;
